import type { Strapi4ResponseSingle } from '@nuxtjs/strapi/dist/runtime/types'
import { apiRequestWrapper } from '~/helpers/apiRequestWrapper'
import type { CompanyFileCategories } from '~/types/components/CompanyFileCategories'
import type { IssueFileCategories } from '~/types/components/IssueFileCategories'
import type { Issue } from '~/types/Issue'

export const CompanyFileCategoriesKeys: { [key in keyof Omit<CompanyFileCategories, 'id'>]: string } = {
  baseProspectus: 'baseProspectus',
  cashFlowStatement: 'cashFlowStatement',
  financialStatement: 'financialStatement',
  balanceSheet: 'balanceSheet',
  incomeStatement: 'incomeStatement',
  annualReport: 'annualReport',
  auditReport: 'auditReport',
  otherDocuments: 'otherDocuments',
}

export function buildFileCategoriesPopulate(keys: string[]) {
  return keys.reduce((acc, key) => {
    acc[key] = {
      populate: {
        files: {
          populate: { file: { fields: ['name', 'url'] } },
        },
      },
    }
    return acc
  }, {} as Record<string, unknown>) // TODO: fix any
}

export const IssueFileCategoriesKeys: { [key in keyof Omit<IssueFileCategories, 'id'>]: string } = {
  issueTermSheet: 'issueTermSheet',
  collateralInstruments: 'collateralInstruments',
  prospectusAmendment: 'prospectusAmendment',
  otherDocuments: 'otherDocuments',
  amendmentToTermSheet: 'amendmentToTermSheet',
}

export function populateCompanyDetails() {
  return {
    lustration: {
      populate: {
        insolvency: '*',
        liquidation: '*',
        unreliableVat: '*',
      },
    },
    identification: '*',
    blogs: {
      populate: {
        author: '*',
        poster: '*',
      },
    },
    contact: '*',
    financialResults: {
      populate: ['statements'],
    },
    statutory: '*',
    ownerships: '*',
    extendedDetail: '*',
    fileCategories: {
      populate: buildFileCategoriesPopulate(Object.keys(CompanyFileCategoriesKeys)),
    },
    issues: {
      publicationState: 'live',
      populate: {
        interestRate: '*',
      },
    },
    heroSection: {
      populate: {
        image: '*',
        video: '*',
      },
    },
    news: '*',
  }
}

export async function getIssueDetails(slug: string) {
  return apiRequestWrapper<Strapi4ResponseSingle<Issue>>(`/issues/0`, {
    customQuery: { slug },
    populate: {
      termSheet: '*',
      interestRate: '*',
      returns: '*',
      heroSection: {
        populate: ['youtubeUrl', 'image', 'video'],
      },

      collaterals: {
        populate: {
          textVariables: '*',
          files: {
            populate: {
              file: { fields: ['name', 'url'] },
            },
          },
        },
      },

      fileCategories: {
        populate: buildFileCategoriesPopulate(Object.keys(IssueFileCategoriesKeys)),
      },

      company: {
        populate: populateCompanyDetails(),
      },
    },
  })
}
